import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import MessageList from "./MessageList";

export class MessageRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/messages"} component={MessageList} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};